import { Component, OnInit, ChangeDetectorRef  } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RepositoryService } from './../../shared/services/repository.service';
import { HorizonScanning } from '../../_interfaces/HorizonScanning.model';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { formatDate } from '@angular/common';
import { take, tap } from 'rxjs/operators';
import { RiskUser } from '../../_interfaces/RiskUser.model';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-horizon-scanning',
  templateUrl: './horizon-scanning.component.html',
  styleUrls: ['./horizon-scanning.component.css']
})
export class HorizonScanningComponent implements OnInit {

  public risks: HorizonScanning[];
  printPdf = false;
  public date: string;
  public user$: Subject<RiskUser> = this.repository.user$;

  constructor(
    private repository: RepositoryService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.getHorizonScans();
    this.setDate();
  }
  public getHorizonScans() {
    let apiAddress: string = `horizonscanning`;

    this.repository.getData(apiAddress)
      .subscribe(res => {
        this.risks = res as HorizonScanning[];
      });
  }

  public getHorizonScanningDetail(Id: number) {
    let detailUrl: string = `/horizon/${Id}`;
    this.router.navigate([detailUrl]);
  }

  public addNew() {
    let url: string = `/add-horizon`;
    this.router.navigate([url]);
  }

  public editHorizonScanningRecord(Id: number) {
    let detailUrl: string = `/add-horizon/${Id}`;
    this.router.navigate([detailUrl]);
  }

  public saveAsPdf(): void {
    this.printPdf = true;

    //show any overflow in the table
    document.getElementById('table').style.overflow = 'visible'

    try {
      this.cdr.detectChanges();
    } catch (e) {
      alert("Problem printing pdf: " + e)
    }

    window.print();

    document.getElementById('table').style.overflow = 'hidden'
    this.printPdf = false;

  }

  setDate() {
    // ToDo - set date field (string) to be today's date in dd-mm-yy format to be used for file name and title
    const today = new Date();
    this.date = formatDate(today, 'dd-MM-yy', 'en'); // "dd-mm-yy";
  }

  archive(id: number) {
    var result = confirm("Are you sure that you want to archive Emerging Risk " + id + " ?");
    if (!result) { return; }

    this.repository.delete(`horizonscanning/${id}`).pipe(
      take(1),
      tap(() => this.getHorizonScans())
    ).subscribe(res => {
      this.risks = res as HorizonScanning[];
    },
      error => {
      alert(error.error);
    });
  }
}
